import { Injectable } from '@angular/core';

@Injectable()
export class DeviceTypeService {

  constructor() { }
}
